import {Box, Card, styled} from '@mui/material';

export const StyledCard = styled(Card)`
	padding: 24px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		flex-direction: row;
		width: 100%;
		align-items: center;
		justify-content: center;
		margin: 0 auto;
	}
`;

export const ImageContainer = styled(Box)`
	margin-inline: auto;

	& img {
		max-width: 100%;
	}
`;
